export const RIGHT_SIDEBAR_PORTAL_TARGET_ID = 'right-sidebar-portal';
